import * as React from "react";
import DeviceContext from "../../../service/indentifyDevice";
import LimitsLayoutDsk from "../limitsLayout/limitsLayoutDsk";
import LimitsLayoutTab from "../limitsLayout/limitsLayoutTab";
import { AGetEquityLimits, AGetCommLimits } from "../../../service/limits/limitsApiService";
import { RouteChildrenProps, Redirect } from "react-router-dom";
import { ILimitsRouteParams, ILimitsData } from "../../../types/components/limits/limitsTypes";
import LimitsLayoutMob from "../limitsLayout/limitsLayoutMob";
import { jwtToken, IListObj } from "../../../types/genericTypes";
import LoginService from "../../../service/login/loginService";

export interface ILimitsContainerProps {}

export interface ILimitsContainerState {
	limitsData: ILimitsData;
	showLoader: boolean;
}

class LimitsContainer extends React.Component<ILimitsContainerProps & RouteChildrenProps<ILimitsRouteParams>, ILimitsContainerState> {
	state = { limitsData: {}, showLoader: true };
	currentRouteParam?: ILimitsRouteParams["asset"];

	getEquityLimitsRes = (res: any) => {
		this.setState({ showLoader: false });

		// check if there is any key in data
		// because data is empty even if not authenticated
		if (res.response.data && res.response.infoID === "0") {
			const header: ILimitsData["header"] = {
				availableLimits: res.response.data.tAL,
				utilizedLimits: `${+res.response.data.cE.pOA + +res.response.data.mUzd.mUtsd + +res.response.data.tTP.tTPV}`,
				cshAvl: res.response.data.cV
			};

			const leftCol: ILimitsData["leftCol"] = {
				payIn: res.response.data.cE.pIA,
				clearCB: res.response.data.cE.cCB,
				notionalCash: res.response.data.cE.nC,
				adHocMargin: res.response.data.cE.ad,
				collateralValue: res.response.data.cV
			};

			const rightCol: ILimitsData["rightCol"] = {
				payOut: res.response.data.cE.pOA,
				marginUtilised: res.response.data.mUzd.mUtsd,
				realisedMtm: res.response.data.mUzd.rMTM,
				unrealisedMtm: res.response.data.mUzd.unrMTM,
				spanExposure: res.response.data.mUzd.sAE,
				others: res.response.data.mUzd.oth,
				blocked: res.response.data.tTP.tTPV,
				mfss: res.response.data.tTP.mfA
			};

			this.setState({ limitsData: { header, leftCol, rightCol } });
		}
	};

	getCommodityLimitsRes = (res: any) => {
		this.setState({ showLoader: false });

		if (res.data) {
			const header: ILimitsData["header"] = {
				availableLimits: res.data.lmt.lmAvl,
				utilizedLimits: `${+res.data.lmt.mrUzd + +res.data.lmt.poAmt}`,
				cshAvl: res.data.lmt.lrB
			};

			const leftCol: ILimitsData["leftCol"] = {
				payIn: res.data.lmt.piAmt,
				clearCB: res.data.lmt.lrB,
				collateralValue: res.data.lmt.colVal
			};

			const rightCol: ILimitsData["rightCol"] = {
				payOut: res.data.lmt.poAmt,
				marginUtilised: res.data.lmt.mrUzd
			};

			this.setState({ limitsData: { header, leftCol, rightCol } });
		}
	};

	callApi(asset?: ILimitsRouteParams["asset"]) {
		this.setState({ showLoader: true });
		if (asset === "equity") {
			AGetEquityLimits(this.getEquityLimitsRes);
		} else if (asset === "comm") {
			AGetCommLimits(this.getCommodityLimitsRes);
		}
	}

	componentDidMount() {
		// call the api initially
		this.currentRouteParam = this.props.match?.params.asset;
		this.callApi(this.currentRouteParam);
	}

	componentDidUpdate() {
		// call api only if route is changed
		if (this.props.match?.params.asset !== this.currentRouteParam) {
			this.currentRouteParam = this.props.match?.params.asset;
			this.callApi(this.currentRouteParam);
		}
	}

	secNavOptions(): Array<IListObj> {
		let pToken: jwtToken | null = LoginService.pToken;

		if (pToken && pToken.accType === "EQ") {
			return [{ display: "Equity", value: "equity", href: "equity" }];
		}

		if (pToken && pToken.accType === "CO") {
			return [{ display: "Commodity", value: "comm", href: "comm" }];
		}

		if (pToken && pToken.accType === "COMEQ") {
			return [
				{ display: "Equity", value: "equity", href: "equity" },
				{ display: "Commodity", value: "comm", href: "comm" }
			];
		}

		return [];
	}

	get layoutProps() {
		return {
			limitsData: this.state.limitsData,
			secNavOptions: this.secNavOptions(),
			showLoader: this.state.showLoader,
			tryAgain: () => this.callApi(this.currentRouteParam)
		};
	}

	render() {
		if (LoginService.pToken?.accType === "EQ" && this.currentRouteParam !== "equity") {
			return <Redirect to={"/limits/equity"} />
		}
		if (LoginService.pToken?.accType === "CO" && this.currentRouteParam !== "comm") {
			return <Redirect to={"/limits/comm"} />
		}

		return DeviceContext().isDesktop ? (
			<LimitsLayoutDsk {...this.layoutProps} />
		) : DeviceContext().isTablet ? (
			<LimitsLayoutTab {...this.layoutProps} />
		) : (
			<LimitsLayoutMob {...this.layoutProps} />
		);
	}
}

export default LimitsContainer;
